import { ModalOption, ModalResult } from '@client/store/modalStore';

/**
 * 모달 플러그인 타입 정의
 * - TType: 모달 타입 문자열
 * - TOption: 모달을 열 때 전달하는 옵션 타입
 * - TReturn: 모달 닫을 때 반환값 타입
 */
export type ModalPlugin<TType extends string, TOption, TReturn = void> = {
    type: TType;
    component: React.ComponentType<{ modalId: string; option: ModalOption }>;
    createModalOption: (option: TOption) => Omit<ModalOption, 'type'>;
};

/**
 * 플러그인을 생성하는 팩토리 함수
 * - 타입 추론을 위해 사용
 */
export const createPlugin = <TType extends string, TOption, TReturn = void>(
    plugin: ModalPlugin<TType, TOption, TReturn>,
): ModalPlugin<TType, TOption, TReturn> => plugin;

/**
 * Record<key, Plugin> → { key: (option) => Promise<ModalResult<TReturn>> } 타입 자동 생성
 */
export type PluginNamespaceApi<TPlugins extends Record<string, ModalPlugin<string, any, any>>> = {
    [K in keyof TPlugins]: TPlugins[K] extends ModalPlugin<any, infer TOption, infer TReturn>
        ? undefined extends TOption
            ? (option?: TOption) => Promise<ModalResult<TReturn>>
            : (option: TOption) => Promise<ModalResult<TReturn>>
        : never;
};
